import { ApiType } from "@gymflow/common";
import { useQuery, UseQueryOptions } from "@tanstack/react-query";

import { availabilityQueryKeys } from "./availabilityQueryKeys";

export function useQueryHostAvailabilityOverrideList(
  {
    api,
    staffId,
    opts,
  }: {
    api: ApiType;
    staffId: Parameters<ApiType["availabilityApi"]["listHostOverride"]>[0];
    opts?: Parameters<ApiType["availabilityApi"]["listHostOverride"]>[1];
  },
  queryOpts?: Omit<
    UseQueryOptions<
      Awaited<
        ReturnType<ApiType["availabilityApi"]["listHostOverride"]>
      >["data"]
    >,
    "queryKey"
  >,
) {
  const result = useQuery({
    queryKey: availabilityQueryKeys.listHostOverrides(staffId as string, opts),
    queryFn: async () => {
      const result = await api.availabilityApi.listHostOverride(
        staffId as string,
        opts!,
      );
      return result.data;
    },
    enabled: !!staffId,
    ...queryOpts,
  });

  return result;
}
